import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f9682f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "accordionHiragana",
  class: "accordion"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paint-brush" }, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = { class: "fa fa-chevron-down" }
const _hoisted_5 = { class: "submenu" }
const _hoisted_6 = { class: "flex-container" }
const _hoisted_7 = {
  id: "accordionKatakana",
  class: "accordion"
}
const _hoisted_8 = {
  class: "default open",
  "class:open": "{katakana.isActive}",
  "class:default": "{katakana.isActive}"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paint-brush" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode()
const _hoisted_11 = { class: "fa fa-chevron-down" }
const _hoisted_12 = { class: "submenu" }
const _hoisted_13 = { class: "flex-container" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paint-brush" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode()
const _hoisted_17 = { class: "fa fa-chevron-down" }
const _hoisted_18 = { class: "submenu" }
const _hoisted_19 = { class: "flex-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownIcon = _resolveComponent("DownIcon")!
  const _component_PercentageLetter = _resolveComponent("PercentageLetter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["default open", {'open': _ctx.hiragana.isActive, 'default' : _ctx.hiragana.isActive}])
      }, [
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[0] || (_cache[0] = () => _ctx.hiragana.isActive = !_ctx.hiragana.isActive)
        }, [
          _hoisted_2,
          _hoisted_3,
          _createElementVNode("h3", null, _toDisplayString(_ctx.hiragana.title), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.hiragana.percentage) + " ", 1),
          _createElementVNode("i", _hoisted_4, [
            _createVNode(_component_DownIcon)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiragana.items, (item) => {
              return (_openBlock(), _createBlock(_component_PercentageLetter, {
                key: item.id,
                percentage: item.percentage,
                letter: item.kana
              }, null, 8, ["percentage", "letter"]))
            }), 128))
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("ul", _hoisted_7, [
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("div", {
          class: "link",
          onClick: _cache[1] || (_cache[1] = () => _ctx.katakana.isActive = !_ctx.katakana.isActive)
        }, [
          _hoisted_9,
          _hoisted_10,
          _createElementVNode("h3", null, _toDisplayString(_ctx.katakana.title), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.katakana.percentage) + " ", 1),
          _createElementVNode("i", _hoisted_11, [
            _createVNode(_component_DownIcon)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.katakana.items, (item) => {
              return (_openBlock(), _createBlock(_component_PercentageLetter, {
                key: item.id,
                percentage: item.percentage,
                letter: item.kana
              }, null, 8, ["percentage", "letter"]))
            }), 128))
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataN5, (header, j) => {
      return (_openBlock(), _createElementBlock("ul", {
        key: header.id,
        id: "accordion{header.title}",
        class: "accordion"
      }, [
        _createElementVNode("li", {
          class: _normalizeClass(["default open", {'open': header.isActive, 'default' : header.isActive}])
        }, [
          _createElementVNode("div", {
            class: "link",
            onClick: () => _ctx.setActive(j)
          }, [
            _hoisted_15,
            _hoisted_16,
            _createElementVNode("h3", null, _toDisplayString(header.title), 1),
            _createTextVNode(" " + _toDisplayString(header.percentage) + " ", 1),
            _createElementVNode("i", _hoisted_17, [
              _createVNode(_component_DownIcon)
            ])
          ], 8, _hoisted_14),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(header.items, (item) => {
                return (_openBlock(), _createBlock(_component_PercentageLetter, {
                  key: item.id,
                  percentage: item.percentage,
                  letter: item.kanji
                }, null, 8, ["percentage", "letter"]))
              }), 128))
            ])
          ])
        ], 2)
      ]))
    }), 128))
  ], 64))
}